import React, { useState } from "react";
import "./Contact.css";
import Subtitle from '../components/Subtitle';
import Title from "../components/Title";
import Paragraph from "../components/Paragraph";
import Button from '../components/Button';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you! Your message has been sent.");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <Subtitle text='Get in Touch' css3='subtitle'/>
        <Title text2='Contact Us' css6='text6'/>
        <div className="line-contact"></div>
        <Paragraph text2='Schedule a consultation with our legal team' css7='paragraph2'/>
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            rows="5"
            required
          />
        <Button text="Send Message" css4="button2"/>
        </form>
      </div>
    </section>
  );
};

export default Contact;